<template>
  <div class="adv-listing-filters-clear">
    <a :href="getUrlNoFilters" class="adv-listing-filters-clear-btn">{{ t('filters.clear.all') }}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedFiltersClear',
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ])
  }
}
</script>

<style lang="scss" scoped>
.adv-listing-filters-clear {
  position: relative;
  display: grid;
  align-items: center;
  width: 100%;
  height: 100%;
  border-right: 1px solid #707070;
  &-btn {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 13px;
    line-height: 1.2;
    color: black;
  }
}
</style>
